import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { cloneDeep } from "lodash-es";
import { Finishing, PageSize } from 'src/app/shared-lib/core/settings';
import { _PrintFile } from 'src/app/shared-lib/domains/product';
import { LaminationOptionsComponent } from "../../home-new/lamination-options/lamination-options.component";
import { FileService } from "../../shared/file.service";
import { UtilsService } from "../../shared/services/utils.service";
import { CoverSettingsComponent } from "../cover-settings/cover-settings.component";
import {
  IndividualBindingOptionsModalComponent
} from "../individual-binding-options-modal/individual-binding-options-modal.component";

@Component({
  selector: 'app-individual-settings',
  templateUrl: './individual-settings.component.html',
  styleUrls: ['./individual-settings.component.scss'],
  standalone: false
})
export class IndividualSettingsComponent implements OnInit {
  appSettings;
  pFile: _PrintFile;
  availableSettings = [];
  printProduct;
  printingGroup;
  blankSheetsBefore;
  blankSheetsAfter;
  alias;
  docColor;
  coverType;
  laminationWeight;
  laminationType;
  coverLaminated;
  ringColor;
  hardCoverFront;
  hardCoverBack;
  fileSettings;
  index;

  constructor(private modalController: ModalController, public fileService: FileService, public utils: UtilsService) {
  }

  ngOnInit() {
    this.availableSettings = this.getAvailableSettings();
    this.blankSheetsBefore = this.pFile.blankSheetsBefore || 0;
    this.blankSheetsAfter = this.pFile.blankSheetsAfter || 0;
    this.alias = this.pFile.alias;
    this.docColor = this.pFile.docColor ? 'color' : 'bn';
    this.coverType = cloneDeep(this.pFile.coverType);
    this.laminationWeight = this.pFile.laminationWeight;
    this.laminationType = this.pFile.laminationType;
    this.coverLaminated = this.pFile.coverLaminated;
    this.ringColor = this.appSettings.ringColor.options.find(rc => rc.value.id == this.pFile.ringColor.id).value ?? this.pFile.ringColor;
    this.hardCoverFront = this.appSettings.hardCoverFront.options.find(hc => hc.value.id == this.pFile.hardCoverFront.id).value ?? this.pFile.hardCoverFront;
    this.hardCoverBack = this.appSettings.hardCoverBack.options.find(hc => hc.value.id == this.pFile.hardCoverBack.id).value ?? this.pFile.hardCoverBack;
  }

  // TODO: To helper (dont know which one)
  private getAvailableSettings() {
    switch (this.printingGroup.printSettings.finishing) {
      case Finishing.NONE:
        //en el futuro aqui tambine estara el guillotinado de bordes blancos
        return ['coverType', 'docColor', 'blankSheets'];
      case Finishing.STAPLED:
      case Finishing.PERFORATED2:
      case Finishing.PERFORATED4:
        return ['coverType', 'docColor', 'blankSheets'];
      case Finishing.LAMINATED:
        return ['coverType', 'docColor', 'laminating'];
      case Finishing.BINDING:
      case Finishing.BINDING_LAMINATED: {
        const result = ['coverType', 'docColor', 'blankSheets'];
        if (!this.printingGroup.printSettings.grouped || this.index === 0) {
          result.push('binding');
        }
        return result;
      }
    }
    return [];
  }

  changeBlankSheetsQty(event, position) {
    const qty = event.qty;
    position === 'before' ? this.blankSheetsBefore = qty : this.blankSheetsAfter = qty;
  }

  protected readonly Finishing = Finishing;

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    const data = {
      alias: this.alias,
      blankSheetsBefore: this.blankSheetsBefore,
      blankSheetsAfter: this.blankSheetsAfter,
      docColor: this.docColor,
      coverType: this.coverType,
      laminationWeight: this.laminationWeight,
      laminationType: this.laminationType,
      coverLaminated: this.coverLaminated,
      ringColor: this.ringColor,
      hardCoverFront: this.hardCoverFront,
      hardCoverBack: this.hardCoverBack,
    };
    this.modalController.dismiss(data);
  }

  get currentCoverTypeData() {
    return this.fileService.getCoverSettings().find(cs => cs.value.id === this.coverType?.id);
  }

  async openCoverSettings() {
    const modal = await this.modalController.create({
      component: CoverSettingsComponent,
      componentProps: {
        fileSettings: this.fileSettings,
        currentCoverType: this.coverType
      },
      cssClass: "auto-height",
    });
    await modal.present();

    modal.onDidDismiss().then((resp) => {
      const { data } = resp;
      if (data?.coverType) {
        this.coverType = data.coverType;
      }
    });
  }

  restartCoverType() {
    // TODO: To helper (dont know which one)
    const _file = {
      coverType: this.coverType,
      coverLaminated: this.pFile.coverLaminated,
      docColor: this.docColor === 'color'
    };
    this.fileSettings.docColor = this.docColor === 'color';
    this.coverType = {
      ...this.fileService.getDefaultCoverType(_file, this.printingGroup.printSettings),
      default: true,
      ...(this.pFile.coverType.paperWeightChanged !== undefined && { paperWeightChanged: this.pFile.coverType.paperWeightChanged })

    };
  }

  async openLaminationSettings() {
    const modal = await this.modalController.create({
      component: LaminationOptionsComponent,
      componentProps: {
        isModal: true,
        file: this.pFile,
        showButtons: true,
        settings: this.appSettings,
        laminationWeight: this.pFile.laminationWeight,
        laminationType: this.pFile.laminationType,
      },
      cssClass: "auto-height modal-width-400",
    });
    await modal.present();

    modal.onDidDismiss().then((resp) => {
      const { data } = resp;
      if (data?.laminationWeight) {
        this.laminationWeight = data.laminationWeight;
        this.laminationType = data.laminationType;
      }
    });
  }


  async openIndividualBindingSettings() {
    const modal = await this.modalController.create({
      component: IndividualBindingOptionsModalComponent,
      componentProps: {
        settings: this.appSettings,
        printProduct: this.printProduct,
        file: this.pFile,
        isModal: true,
      },
      backdropDismiss: false,
      cssClass: "auto-height modal-width-400",
    });
    await modal.present();

    modal.onDidDismiss().then((resp) => {
      const { data } = resp;
      if (data) {
        const ringColorValue = data.settings.ringColor.options[data.settings.ringColor.selected - 1].value;
        const hardCoverFrontValue = data.settings.hardCoverFront.options[data.settings.hardCoverFront.selected - 1].value;
        const hardCoverBackValue = data.settings.hardCoverBack.options[data.settings.hardCoverBack.selected - 1].value;
        const laminationTypeValue = data.settings.laminationType.options[data.settings.laminationType.selected - 1].value;
        const laminationWeightValue = data.settings.laminationWeight.options[data.settings.laminationWeight.selected - 1].value;

        this.ringColor = ringColorValue;
        this.hardCoverFront = hardCoverFrontValue;
        this.hardCoverBack = hardCoverBackValue;
        this.laminationType = laminationTypeValue;
        this.laminationWeight = laminationWeightValue;
        this.fileSettings.ringColor = this.ringColor;
        this.fileSettings.hardCoverFront = this.hardCoverFront;
        this.fileSettings.hardCoverBack = this.hardCoverBack;
        if (!!this.printingGroup.printSettings.grouped && this.printingGroup.printSettings.finishing === Finishing.BINDING_LAMINATED) {
          for (let f of this.printingGroup.files) {
            f.laminationType = laminationTypeValue;
            f.laminationWeight = laminationWeightValue;
          }
        }
      }
    });
  }

  protected readonly PageSize = PageSize;
}
